module.exports = __webpack_public_path__ + "static/media/creditCardRightSideBG2.d121d67d.svg";